import React from 'react';
import foldStyle from './style';

export default function SubSubtitle() {
	let style = foldStyle();
	return <p style={style.subSubTextStyle()}>“I can always strive to be better than who I was yesterday”</p>;
}
